export default {
  AKTUELL: 1,
  BEARBEITUNG: 2,
  ZUKUENFTIG: 3,
  UNGUELTIG: 4 
};
